module.exports = __webpack_public_path__ + "static/cy-c51233600310737dcf32ad3801944ab4.svg";